import Button from '@mui/material/Button';
import MessageBox from './MessageBox';
import React from 'react';

const ResetPasswordSuccess = () => {
  return (
    <MessageBox
      header="Excellent news!"
      message="Your password has been successfully reset."
      secondaryMessage={
        <Button
          color="secondary"
          style={{ width: '100%' }}
          onClick={ () => window.location.href = '/' }
        >
          Login
        </Button>
      }
    />
  )
}

export default ResetPasswordSuccess;
